export const getDateInJP = (dateObj) => {
  const year = dateObj.getFullYear()
  const month = dateObj.getMonth()
  const date = dateObj.getDate()
  const hour = dateObj.getHours()
  const minutes = dateObj.getMinutes()
  return `${year}年${month}月${date}日 ${hour}時${minutes}分`
}
